import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ResponsiveText from '~/components/ResponsiveText';

const Wrap = styled.div`
	flex-basis: 50%;
	display: flex;
	height: 100px;
	margin: 12px 0;
	width: 100%;
	max-width: 336px;
`;

const IconWrap = styled.div`
	width: 24px;
	margin-right: 8px;
`;

const TextWrap = styled.div`
	display: flex;
	flex-direction: column;
`;

const StreamYardForCard = ({ body, header, icon }) => (
	<Wrap>
		<IconWrap>{icon}</IconWrap>
		<TextWrap>
			<ResponsiveText component="h2" variant="h5">
				{header}
			</ResponsiveText>
			<ResponsiveText variant="body">{body}</ResponsiveText>
		</TextWrap>
	</Wrap>
);

StreamYardForCard.propTypes = {
	body: PropTypes.node.isRequired,
	header: PropTypes.node.isRequired,
	icon: PropTypes.node.isRequired,
};

export default StreamYardForCard;
